import React from "react";
import { custom } from "./interface";
import styles from './style.module.css'

const CustomButton: React.FC<custom> = ({ title, onClick, disabled, classes }) => {
    return <button className={`${styles.container} ${styles.text} ${disabled ? styles.disable : ''} ${classes}`} onClick={onClick}>{title}</button>;
};
export default CustomButton;